import { useQueryRefHandlers, useReadQuery } from '@apollo/client';
import { Suspense } from 'react';
import { ClientLoaderFunction } from 'react-router';
import { ErrorBanner } from '@/components/error-page/error-banner.tsx';
import { StreamList } from '@/components/stream-list/stream-list.tsx';
import {
  profileStreamsLoader,
  useProfileStreamsLoaderData,
} from '@/routes/_app.$username._index/loader.ts';
import { EmptyStreamList } from '@/routes/_app.$username.streams/empty-profile-stream-list.tsx';

export const clientLoader = profileStreamsLoader;
(clientLoader as ClientLoaderFunction).hydrate = true;

export const ProfileStreamFeedComponent = () => {
  const { streamsQueryRef } = useProfileStreamsLoaderData();

  const { fetchMore } = useQueryRefHandlers(streamsQueryRef);
  const {
    data: { userStreams },
  } = useReadQuery(streamsQueryRef);

  return (
    <StreamList
      streams={userStreams.items}
      hasNext={!!userStreams.nextToken}
      loadMore={() => {
        fetchMore({
          variables: {
            nextToken: userStreams.nextToken,
          },
        });
      }}
      emptyState={<EmptyStreamList />}
    />
  );
};

export const ErrorBoundary = ErrorBanner;
export default function ProfileFeed() {
  return (
    <Suspense fallback={null}>
      <ProfileStreamFeedComponent />
    </Suspense>
  );
}
